import Head from 'expo-router/head';

import { OrderScreen } from '@fhs/cart';

export default function OrderStatusPage() {
  return (
    <>
      <Head>
        <title>Order Status - Firehouse Subs</title>
      </Head>
      <OrderScreen />
    </>
  );
}
